/* Lifecycle Recon search rows, rebuilt from the loaded list (B-284).
 *
 * search_inventory returns Tools documents and never reads LifecycleProfile,
 * so a search row has no disposition, and its list_number / recon_status are
 * the Tools document's. The loaded list (manage_lifecycle_profile
 * action=list) is the Tools document with the profile merged over it, plus
 * completeness, part_numbers and asset_tags. It carries every field a search
 * row does except _match_context.
 *
 * So the search decides WHICH rows show, and each row's fields come from its
 * loaded row, with the search row's _match_context laid on top. The whole
 * loaded row is taken, not a list of fields, so the badge, the list number,
 * the recon status and every grid column agree with the unsearched list. A
 * search row with no loaded row (a tool added since the list loaded) is
 * returned unchanged.
 *
 * Disposal Recon keeps its own completeness-only merge: its list fields are
 * Tools fields (B-287).
 */

export function mergeSearchRowsWithLoaded(searchRows, loadedTools) {
  const byId = new Map();
  for (const t of (loadedTools || [])) {
    byId.set(t.id || t.tool_id, t);
    if (t.tool_id) byId.set(t.tool_id, t);
  }
  return (searchRows || []).map(r => {
    const loaded = byId.get(r.id) || byId.get(r.tool_id);
    if (!loaded) return r;
    const merged = { ...loaded };
    if ('_match_context' in r) merged._match_context = r._match_context;
    return merged;
  });
}
